module.exports = __webpack_public_path__ + "img/sale2.505c77e3.png";